import form from './form';
import table from './table';
export default {
  layout: 'medical-licenses-layout',
  table,
  form,
  grid: 'medical-license-grid',
};
